import './App.css';
import { BrowserRouter as Router, Route, Routes, Navigate } from 'react-router-dom'; // Import BrowserRouter
import Main from './sections/main';
import WallOfFame from './page 2/9-wallOfFlame';
import Layout from './sections/layout';
import Card1 from './page 3/card1';
import Card1Detail from './page 3/card1';
import CardDetail2 from './page 3/Card2';
import CardDetail6 from './page 3/card6';
import CardDetail5 from './page 3/card5';
import CardDetail4 from './page 3/card4';
import CardDetail3 from './page 3/card3';

function App() {
  return (
    <div>
      <Router>
        <Layout>
        <Routes>
          <Route path="/" element={<Main />} />
          {/* <Route path="/walloffame" element={<WallOfFame />} /> */}
          <Route path="/communityTradersMain/@cryptonoan" element={<Card1Detail />} />
          <Route path="/communityTradersMain/@drbuny" element={<CardDetail2 />} />
          <Route path="/communityTradersMain/@overdose_gems_group" element={<CardDetail3 />} />
          <Route path="/communityTradersMain/@spicygems" element={<CardDetail4 />} />
          <Route path="/communityTradersMain/@crazylandinhabitant" element={<CardDetail5 />} />
          <Route path="/communityTradersMain/@ricardo" element={<CardDetail6 />} />
          <Route index element={<Main />} />
            
            {/* Add a catch-all route to handle 404 errors */}
            <Route path="*" element={<Navigate to="/" />} />
        </Routes>
        </Layout>
      </Router>
    </div>
  );
}

export default App;
